module.exports = __webpack_public_path__ + "static/img/build5.47ea139e.png";